import { AdPlacement } from "@/components/ads/AdPlacement";
import {
  SciBreadcrumb,
  SciExplainer,
  SciHeader,
  SciPage,
} from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { PiePlot } from "../components/PiePlot";

export function CalculatorPage() {
  return (
    <SciPage>
      <SciBreadcrumb
        homeLabel={m.sci_breadcrumb_home()}
        toolName={m.pie_tool_name()}
        toolPath="/pie-chart"
      />
      <SciHeader title={m.pie_h1()} intro={m.pie_intro()} />

      <PiePlot />

      <SciExplainer
        howToTitle={m.sci_howto_title()}
        howTo={m.pie_howto()}
        examplesTitle={m.sci_examples_title()}
        examples={[m.pie_ex1(), m.pie_ex2(), m.pie_ex3()]}
        faqTitle={m.sci_faq_title()}
        faqs={[
          { q: m.pie_faq_q1(), a: m.pie_faq_a1() },
          { q: m.pie_faq_q2(), a: m.pie_faq_a2() },
          { q: m.pie_faq_q3(), a: m.pie_faq_a3() },
          { q: m.pie_faq_q4(), a: m.pie_faq_a4() },
        ]}
      />

      <AdPlacement className="mt-10" />
    </SciPage>
  );
}
